import type { FaireProductEntity } from "../../entity_types/product";

export const p_gj6jh5a2ru: FaireProductEntity = {
  token: "p_gj6jh5a2ru",
  type: "product",
  name: "DARKER THE CHERRY",
  brandToken: "b_8rgv5suw2a",
  brandName: "Portrait Coffee",
  imageUrl: "https://cdn.faire.com/fastly/5d5016cf05b3ea752498abe1cb586d12dfddd09e4d898aa557b4b7f80a7fa390.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33fbbd3383ff8b4faba98b7e6dcaf6104bea6a7c6b41588e8c4179e47f1a713f.jpeg",
    "https://cdn.faire.com/fastly/04b5e6807fc3b34ce401f74c0fdf9ffeab0ae3b41948c9243e8781f988507c98.png",
    "https://cdn.faire.com/fastly/1f03c3ba4d35241f8618c2cefb09f417541dc780d5c91dd8fcd4ad0d41e805fa.png"
  ],
  priceDollars: 73.5,
  description: "Dark, Roasty, Rich\n\nSometimes coffee needs to breathe a little and let its hair down. Darker the Cherry is roasted and toasted to perfection for coffee drinkers who enjoy a rich, roasty cup. Plenty dark, still sweet, with toasted nuts and rich dark chocolate.\n\nTasting Notes: Toasted nuts, dark chocolate\nOrigin: Brazil\nSub Region: Cerrado Mineiro DO\nProducer: Cerrado Mineiro Designation of Origin accredited farms\nVariety: Catuai\nElevation: 1,100 masl\nHarvest Time: June to August\nProcess: Natural / Dry Processed\nRoast Level: Dark\nRecommended Brew: Drip, French press, or espresso\n\nWhole bean or ground, roasted to order in Atlanta. Available in 310 g, 2 lb, and 5 lb.\n",
  tags: [],
  msrpDollars: 122.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:58.117Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
